import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { JobSiteControllers } from './JobSiteControllers';
import { JobSiteDoubleChecks } from './JobSiteDoubleChecks';
import { JobSiteWaterMeters } from './JobSiteWaterMeters';

interface JobSiteDevicesProps {
  jobSiteId: string;
  jobSiteName: string;
  onDataChange?: () => void;
  /**
   * View-only mode — used by the Manager property screen. Passed straight
   * through to each device list so every add / edit / delete affordance is
   * removed rather than merely disabled.
   */
  readOnly?: boolean;
}

type DeviceType = 'controllers' | 'doublechecks' | 'watermeters';

export function JobSiteDevices({ jobSiteId, jobSiteName, onDataChange, readOnly = false }: JobSiteDevicesProps) {
  const { t } = useTranslation('inspection');
  const [activeTab, setActiveTab] = useState<DeviceType>('controllers');

  return (
    <div className="space-y-4">
      <div className="border-b border-line">
        <div className="flex gap-4">
          <button
            onClick={() => setActiveTab('controllers')}
            className={`px-4 py-2 font-medium border-b-2 transition-colors ${
              activeTab === 'controllers'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-theme-secondary hover:text-theme-primary hover:border-line'
            }`}
          >
            {t('devices.tabControllersZones')}
          </button>
          <button
            onClick={() => setActiveTab('doublechecks')}
            className={`px-4 py-2 font-medium border-b-2 transition-colors ${
              activeTab === 'doublechecks'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-theme-secondary hover:text-theme-primary hover:border-line'
            }`}
          >
            {t('devices.tabDoubleChecks')}
          </button>
          <button
            onClick={() => setActiveTab('watermeters')}
            className={`px-4 py-2 font-medium border-b-2 transition-colors ${
              activeTab === 'watermeters'
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-theme-secondary hover:text-theme-primary hover:border-line'
            }`}
          >
            {t('devices.tabWaterMeters')}
          </button>
        </div>
      </div>

      <div>
        {activeTab === 'controllers' && (
          <JobSiteControllers jobSiteId={jobSiteId} jobSiteName={jobSiteName} onDataChange={onDataChange} readOnly={readOnly} />
        )}
        {activeTab === 'doublechecks' && (
          <JobSiteDoubleChecks jobSiteId={jobSiteId} jobSiteName={jobSiteName} onDataChange={onDataChange} readOnly={readOnly} />
        )}
        {activeTab === 'watermeters' && (
          <JobSiteWaterMeters jobSiteId={jobSiteId} jobSiteName={jobSiteName} onDataChange={onDataChange} readOnly={readOnly} />
        )}
      </div>
    </div>
  );
}
